import React from "react";
import styled, { css } from "styled-components";
import Select, { Creatable } from "react-select";
import * as colors from "../../settings/colors";

const isValueInOptions = (options, value, valueKey) => {
  if (!options) return false;
  if (!value) return true;
  return options.map(option => option[valueKey]).indexOf(value) > -1;
};

class SelectInput extends React.Component {
  static defaultProps = {
    allowCreate: false,
    labelKey: "label",
    valueKey: "value"
  };

  constructor(props) {
    super(props);
    const createdOption = isValueInOptions(
      props.options,
      props.value,
      props.valueKey
    )
      ? null
      : props.value;
    this.state = { createdOption };
  }

  componentWillReceiveProps({ value, options, valueKey }) {
    if (value) {
      const createdOption = isValueInOptions(options, value, valueKey)
        ? null
        : value;
      this.setState({ createdOption });
    }
  }

  handleBlur = () => {
    if (this.props.onBlur) {
      this.props.onBlur(this.props.value);
    }
  };

  render() {
    const { createdOption } = this.state;
    const {
      simpleValue,
      value,
      allowCreate = false,
      ...otherProps
    } = this.props;

    const useSimpleValues =
      typeof simpleValue === "undefined" ? true : simpleValue;
    const options =
      allowCreate && createdOption
        ? [
            {
              [otherProps.valueKey]: createdOption,
              [otherProps.labelKey]: createdOption
            },
            ...otherProps.options
          ]
        : otherProps.options;
    const SelectComponent = allowCreate ? Creatable : Select;

    return (
      <SelectComponent
        {...otherProps}
        options={options}
        value={value}
        simpleValue={useSimpleValues}
        onBlur={this.handleBlur}
      />
    );
  }
}

const StyledSelect = styled(SelectInput)`
  & .Select-control,
  &.is-open .Select-control {
    font-size: 14px;
    box-sizing: border-box;
    border: 1px solid ${colors.DIVIDER};
    border-radius: 3px;
    box-shadow: inset 0 1px 2px ${colors.FORM_INPUT_INSET_SHADOW};
  }

  ${({ hasError }) =>
    hasError &&
    css`
      & .Select-control {
        border-color: ${colors.RED};
      }
    `} &.is-open .Select-control {
    border-radius: 3px 3px 0 0;
  }

  & .Select-menu-outer {
    border-color: ${colors.DIVIDER};
  }

  &.is-focused:not(.is-open) .Select-control {
    outline: 0;
    border-color: ${colors.BLUE};
    box-shadow: inset 0 1px 0 ${colors.FORM_INPUT_INSET_SHADOW},
      0 0 0 3px ${colors.FORM_INPUT_FOCUS_RING};
  }

  & .Select-input,
  & .Select-placeholder {
    font-size: 14px;
    padding-left: 9px;
    padding-right: 9px;
  }

  & .Select-input > input {
    font-size: 14px;
    line-height: 18px;
    padding: 8px 0;
  }

  & .Select-input > input {
    color: ${colors.TEXT};
  }

  & .Select-placeholder {
    color: ${colors.TEXT_TERTIARY};
  }

  & .Select-option {
    color: ${colors.TEXT};
    font-size: 14px;
    line-height: 18px;
    padding: 7px 9px;
  }
`;

export default StyledSelect;



// WEBPACK FOOTER //
// ./src/components/forms/Select.js